module.exports = __webpack_public_path__ + "static/kran_buehnenbetrieb-741baf9d95e39a285dcd56fe58440bac.png";